module.exports = __webpack_public_path__ + "static/img/searchLeads-logo.1fe9be17.png";